import React from "react";
import { Box, Stack } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import IndividualSection from "src/scenes/integrations/individual-section";
import OrganizationSection from "src/scenes/integrations/company-wide-section";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import DemoBarPersonal from "src/components/demo-bar-personal";
import DemoBarEnterprise from "src/components/demo-bar-enterprise";
import Portal from "../../components/portal";
import DemoBarDemo from "../../components/demo-bar-demo";

const H1 = styled.h1`
    font-size: 22px;
    margin: 0;
    font-weight: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const H2 = styled.h2`
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;
const Integrations = () => {
    const { activeIntegrations: userIntegrations } = useActiveIntegrations();
    return (
        <>
            <Helmet>
                <title>Adadot - Integrate your tools</title>
            </Helmet>
            <Portal>
                <DemoBarPersonal />
                <DemoBarDemo />
                <DemoBarEnterprise />
            </Portal>
            <Box mb={3} mx={4} pb={1}>
                <Stack direction="column" alignItems="center">
                    <H1>Integrate with your existing tools</H1>
                    <H2>Select a service to integrate or view integration settings</H2>
                </Stack>
            </Box>
            <OrganizationSection userIntegrations={userIntegrations} />
            <IndividualSection userIntegrations={userIntegrations} />
        </>
    );
};

export default Integrations;
